// Author Liu Cui Cui
// Date 2022-07-20 12:18:28

class SithMesTpmProcessDataTpd {
constructor({
        id = null,
        tpdOperatorId = '',
        tpdOperatorName = '',
        tpdOperateSeq = '',
        tpdLocationId = '',
        tpdStartTime = '',
        tpdEndTime = '',
        tpdDuration = '',
        tpdProgramName = '',
        tpdProgramLocation = '',
        tpdToolIdent = '',
        tpdDeviceCode = '',
        tpdDeviceSystemType = '',
        remark = ''}
= {}) {
    this.id = id;
    this.tpdOperatorId = tpdOperatorId;
    this.tpdOperatorName = tpdOperatorName;
    this.tpdOperateSeq = tpdOperateSeq;
    this.tpdLocationId = tpdLocationId;
    this.tpdStartTime = tpdStartTime;
    this.tpdEndTime = tpdEndTime;
    this.tpdDuration = tpdDuration;
    this.tpdProgramName = tpdProgramName;
    this.tpdProgramLocation = tpdProgramLocation;
    this.tpdToolIdent = tpdToolIdent;
    this.tpdDeviceCode = tpdDeviceCode;
    this.tpdDeviceSystemType = tpdDeviceSystemType;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesTpmProcessDataTpd();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdOperatorName',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdOperatorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdDeptName',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdDeptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdProjectCode',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdProjectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdItemName',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdItemName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdOrderCode',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'prdPpOperationName',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.prdPpOperationName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdMstLocName',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdMstLocName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdStartTime',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdEndTime',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdDuration',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdDuration',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdProgramName',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdProgramName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdProgramLocation',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdProgramLocation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdToolIdent',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdToolIdent',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdDeviceCode',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdDeviceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'tpdDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.tpdDeviceSystemType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    tpdOperatorIdFilter : '',
    tpdDeptNameFilter : '',
    tpdProjectCodeFilter : '',
    tpdItemNameFilter : '',
    tpdOrderCodeFilter : '',
    tpdOperateSeqFilter : '',
    tpdLocationIdFilter : '',
    tpdStartTimeRteFilter : '',
    tpdStartTimeLteFilter : '',
    tpdEndTimeRteFilter : '',
    tpdEndTimeLteFilter : '',
    tpdDurationFilter : '',
    tpdProgramNameFilter : '',
    tpdProgramLocationFilter : '',
    tpdToolIdentFilter : '',
    tpdDeviceCodeFilter : '',
    tpdDeviceSystemTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'tpdOperatorIdFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdOperatorId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tpdProjectCodeFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdProjectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdItemNameFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdItemName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdOrderCodeFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdOperateSeqFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdOperateSeq',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tpdLocationIdFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdLocationId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tpdStartTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdStartTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdStartTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdStartTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdEndTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdEndTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdEndTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdEndTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdDurationFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdDuration',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdProgramNameFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdProgramName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdProgramLocationFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdProgramLocation',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdToolIdentFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdToolIdent',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdDeviceCodeFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdDeviceCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdDeviceSystemTypeFilter',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.filter.tpdDeviceSystemType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'tpdOperatorName',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdOperatorName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"tpdOperatorId":"id"}'
                }
        },
        {
        key: 'tpdOperateSeq',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdOperateSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tpdLocationId',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tpdStartTime',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdEndTime',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdDuration',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdProgramName',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdProgramName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdProgramLocation',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdProgramLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdToolIdent',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdToolIdent',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdDeviceCode',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdDeviceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpdDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.tpdDeviceSystemType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmProcessDataTpd.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesTpmProcessDataTpd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
